import types from './types';

const initialState = {
  meta: {
    fetchingTimecards: false,
    error: null
  },
  today: {
    all: [],
    byEmployee: {}
  },
  range: {
    timecards: [],
    clockEditsById: {}
  }
};

export const employeeAttendanceReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_EMPLOYEE_TIMECARDS_IN_RANGE_REQUEST:
    case types.GET_TODAY_CENTER_TIMECARDS_REQUEST: {
      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingTimecards: true,
          error: null
        }
      };
    }
    case types.GET_TODAY_CENTER_TIMECARDS_SUCCESS: {
      const { todayTimecards, byEmployee } = action;

      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingTimecards: false,
          error: null
        },
        today: {
          ...state.today,
          all: todayTimecards,
          byEmployee
        }
      };
    }
    case types.GET_EMPLOYEE_TIMECARDS_IN_RANGE_SUCCESS: {
      const { timecards } = action;

      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingTimecards: false,
          error: null
        },
        range: {
          ...state.range,
          timecards
        }
      };
    }
    case types.GET_EMPLOYEE_TIMECARDS_IN_RANGE_FAILURE:
    case types.GET_TODAY_CENTER_TIMECARDS_FAILURE: {
      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingTimecards: false,
          error: action.error
        }
      };
    }
    case types.SET_EDITS_TO_TIMECARD: {
      return {
        ...state,
        range: {
          ...state.range,
          clockEditsById: {
            ...state.range.clockEditsById,
            [action.timecardId]: {
              timecard_id: action.timecardId,
              start: action.start,
              end: action.end
            }
          }
        }
      };
    }
    case types.UPDATE_TIMECARDS_SUCCESS: {
      let timecardsArr = [...state.range.timecards];
      const idsArr = timecardsArr.map(timecard => timecard.timecard_id);

      Object.keys(action.timecardUpdates).forEach(timecardId => {
        const value = action.timecardUpdates[timecardId];
        const indexToUpdate = idsArr.indexOf(parseInt(timecardId, 10));

        timecardsArr[indexToUpdate] = {
          ...timecardsArr[indexToUpdate],
          start: value.start,
          end: value.end
        };
      });

      return {
        ...state,
        range: {
          ...state.range,
          timecards: timecardsArr,
          clockEditsById: {}
        }
      };
    }
    default:
      return state;
  }
};
